import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const authService = inject(AuthService);

  return from(Promise.all([authService.getToken(), authService.getClientId()])).pipe(
    switchMap(([token, clientId]) => {
      if (token && clientId) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
          setParams: {
            'client-id': clientId,
          },
        });
      }
      return next(request);
    }),
  );
};
